// extracted by mini-css-extract-plugin
export default {"header":"Header_header__vHAVV","icon":"Header_icon__1bzx3"};